import React from 'react';
import classnames from 'classnames';

import InfoIcon from 'images/icon/info.inline.svg';
import styles from './index.css';

const Alert = ({
	children,
	text,
	success,
	className,
	show = false,
	onCloseAlert,
	isDangerouslySetInnerHTML,
}) => (
	<div
		className={classnames(className, styles.alert, {
			[styles.success]: success,
			[styles.show]: show,
		})}
	>
		<i className="material-icons" onClick={onCloseAlert} role="presentation">
			{success ? <InfoIcon /> : 'highlight_off'}
		</i>
		<span className={styles.text}>
			{isDangerouslySetInnerHTML ? <span dangerouslySetInnerHTML={{ __html: text }} /> : text}
			{children}
		</span>
	</div>
);

export default Alert;



// WEBPACK FOOTER //
// ./src/components/atoms/Alert/component.js